import { BusinessType } from '@nemuru-eng/js-api-client';

import { Text } from '@/components/shared/components/Text';

export const BusinessTypeSelectItems = Object.keys(BusinessType).map((value) => ({
  value: value.toLowerCase(),
  display: <Text tId={value.toLowerCase()} />,
}));
